module.exports = {
  siteTitle: 'Ritesh Kumar | Software Engineer',
  siteDescription:
    'Ritesh Kumar has a demonstrated history of working in the computer software industry. Strong engineering professional with a Bachelor’s Degree focused in Computer Science And Engineering from NIT Jaipur.',
  siteKeywords:
    'Ritesh Kumar, Ritesh, Kumar, rk-1203, rk_1203, RK1203, software engineer, front-end engineer, front-end developer, web developer, javascript, java, full-stack',
  siteUrl: 'https://riteshkumar.netlify.app/',
  siteLanguage: 'en_IN',
  googleAnalyticsID: 'UA-168119558-1',
  googleVerification: 'YkZifGxfJTLj56dWuhkvYfsX07g337Oreb_stwIVrwE',
  name: 'Ritesh Kumar',
  location: 'Delhi, India',
  email: 'riteshkumar1203@gmail.com',
  github: 'https://github.com/rk-1203',
  twitterHandle: '@RiteshK07364397',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/rk-1203',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/riteshkumar1203/',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/RiteshK07364397',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
